import { c as _c } from "react/compiler-runtime";
import { getOrgProxyConfigsOptions } from '@onefootprint/fetch-dashboard';
import { getErrorMessage } from '@onefootprint/request';
import { Divider, Pagination } from '@onefootprint/ui';
import { useQuery } from '@tanstack/react-query';
import Head from 'next/head';
import { parseAsString, useQueryState } from 'nuqs';
import { useTranslation } from 'react-i18next';
import SectionHeader from '@/components/section-header';
import { useCursorPagination } from '@/hooks/use-pagination';
import Create from './components/create';
import Table from './components/table';
const PAGE_SIZE = 25;
const CustomIntegrations = () => {
  const $ = _c(45);
  const {
    t
  } = useTranslation("vault-proxy");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsString.withDefault("");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [cursorParam, setCursorParam] = useQueryState("cursor", t0);
  let cursors;
  let t1;
  let t2;
  if ($[1] !== cursorParam) {
    cursors = cursorParam ? cursorParam.split(",") : [];
    t1 = useQuery;
    t2 = getOrgProxyConfigsOptions({
      query: {
        cursor: cursors.at(-1),
        pageSize: PAGE_SIZE
      }
    });
    $[1] = cursorParam;
    $[2] = cursors;
    $[3] = t1;
    $[4] = t2;
  } else {
    cursors = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const {
    data,
    error,
    isPending
  } = t1(t2);
  let t3;
  if ($[5] !== error) {
    t3 = error ? getErrorMessage(error) : undefined;
    $[5] = error;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const errorMessage = t3;
  const t4 = data?.meta.next ?? null;
  let t5;
  if ($[7] !== cursors || $[8] !== setCursorParam || $[9] !== t4) {
    t5 = {
      next: t4,
      cursor: cursors,
      onChange: setCursorParam,
      pageSize: PAGE_SIZE
    };
    $[7] = cursors;
    $[8] = setCursorParam;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const pagination = useCursorPagination(t5);
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <Head><title>{t6}</title></Head>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp2);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <header className="hidden md:flex items-center justify-between mb-6"><h2 className="text-heading-2">{t8}</h2></header>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp3);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp4);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Create />;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t11) {
    t13 = <SectionHeader title={t10} subtitle={t11}>{t12}</SectionHeader>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Divider className="mb-4" />;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  const t15 = data?.data;
  let t16;
  if ($[28] !== errorMessage || $[29] !== isPending || $[30] !== t15) {
    t16 = <Table data={t15} errorMessage={errorMessage} isPending={isPending} />;
    $[28] = errorMessage;
    $[29] = isPending;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== pagination.hasNextPage || $[33] !== pagination.hasPrevPage || $[34] !== pagination.loadNextPage || $[35] !== pagination.loadPrevPage || $[36] !== pagination.pageIndex || $[37] !== pagination.pageSize) {
    t17 = (pagination.hasNextPage || pagination.hasPrevPage) && <Pagination hasNextPage={pagination.hasNextPage} hasPrevPage={pagination.hasPrevPage} onNextPage={pagination.loadNextPage} onPrevPage={pagination.loadPrevPage} pageIndex={pagination.pageIndex} pageSize={pagination.pageSize} />;
    $[32] = pagination.hasNextPage;
    $[33] = pagination.hasPrevPage;
    $[34] = pagination.loadNextPage;
    $[35] = pagination.loadPrevPage;
    $[36] = pagination.pageIndex;
    $[37] = pagination.pageSize;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t13 || $[40] !== t16 || $[41] !== t17 || $[42] !== t7 || $[43] !== t9) {
    t18 = <>{t7}{t9}{t13}{t14}{t16}{t17}</>;
    $[39] = t13;
    $[40] = t16;
    $[41] = t17;
    $[42] = t7;
    $[43] = t9;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
};
export default CustomIntegrations;
function _temp($) {
  return $.pageTitle;
}
function _temp2($_0) {
  return $_0.metaTitle;
}
function _temp3($_1) {
  return $_1.header.title;
}
function _temp4($_2) {
  return $_2.header.subtitle;
}